export enum HandoverInviteStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED'
}
export interface ListHandoverHistoryParams {
  query?: string
  startDate?: string
  endDate?: string
  limit?: number
  offset?: number
  startTime?: string
  endTime?: string
  status?: HandoverInviteStatus[]
  positionName?: string
  unitName?: string
  scheduleName?: string
  operationalGroups?: string[]
}

// === Handover V2 Enums ===

export enum PackageNature {
  HANDOVER = 'HANDOVER',
  OPEN_VACANCY = 'OPEN_VACANCY'
}

export enum PackageRecurrence {
  SINGLE = 'SINGLE',
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY_ABCDE = 'MONTHLY_ABCDE'
}

export enum PackageStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  AWAITING_RESPONSES = 'AWAITING_RESPONSES',
  IN_ADMIN_QUEUE = 'IN_ADMIN_QUEUE',
  APPROVED = 'APPROVED',
  CANCELLED_BY_REQUESTER = 'CANCELLED_BY_REQUESTER',
  CANCELLED_BY_SYSTEM = 'CANCELLED_BY_SYSTEM',
  CANCELLED_BY_CASCADE = 'CANCELLED_BY_CASCADE',
  CANCELLED_BY_STATION_EDIT = 'CANCELLED_BY_STATION_EDIT',
  EXPIRED = 'EXPIRED'
}

/**
 * Espelha `InviteStatusEnum` do backend. Os valores CANCELLED_BY_* que existiam
 * aqui nunca foram emitidos pela API — e EXPIRED/CANCELLED, que são os estados
 * mais comuns de um convite perto do prazo, faltavam. O resultado era a tela
 * cair no fallback e exibir a string crua do backend.
 */
export enum InviteStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED'
}

export enum InviteOrigin {
  DIRECT = 'DIRECT',
  SHOWCASE = 'SHOWCASE'
}

export enum VisibilityLevel {
  SCHEDULE = 'SCHEDULE',
  COMPANY = 'COMPANY',
  OPEN_SEA = 'OPEN_SEA'
}

export enum AllocationStatus {
  ALLOCATED_PENDING = 'ALLOCATED_PENDING',
  ALLOCATED_ACCEPTED = 'ALLOCATED_ACCEPTED',
  ALLOCATED_NOT_ACCEPTED = 'ALLOCATED_NOT_ACCEPTED'
}

export enum TermType {
  HANDOVER = 'HANDOVER',
  ASSUME_SHIFT = 'ASSUME_SHIFT',
  BACKOFFICE_ALLOCATION = 'BACKOFFICE_ALLOCATION'
}

export enum AllocationOrigin {
  SELF_SERVICE = 'SELF_SERVICE',
  DIRECT_INVITE = 'DIRECT_INVITE',
  SHOWCASE = 'SHOWCASE',
  BACKOFFICE = 'BACKOFFICE'
}

// === Handover V2 Request Interfaces ===

export interface ListPendingApprovalsParams {
  query?: string
  scheduleId?: number
  healthUnitId?: number
  nature?: PackageNature
  startDate?: string
  endDate?: string
  expirationStartDate?: string
  expirationEndDate?: string
  operationalGroups?: string[]
  expirationBucket?: ExpirationBucket
  statuses?: HandoverStatusFilter[]
  page?: number
  perPage?: number
}

/** Faixas de urgência da fila de aprovação — espelham o HandoverExpirationBadge. */
export enum ExpirationBucket {
  CRITICAL = 'CRITICAL',
  WARNING = 'WARNING',
  ON_TIME = 'ON_TIME'
}

/**
 * Status do pacote no vocabulário do usuário, aceito pelos DOIS endpoints de
 * aprovação (fila e histórico). O backend expande cada valor para os
 * `PackageStatus` reais — o frontend nunca precisa conhecê-los:
 *
 * | Valor                  | Expande para                          |
 * | ---------------------- | ------------------------------------- |
 * | IN_TRANSITION          | PENDING                               |
 * | IN_ADMIN_QUEUE         | IN_ADMIN_QUEUE                        |
 * | APPROVED               | APPROVED                              |
 * | REJECTED               | CANCELLED_BY_SYSTEM, _CASCADE, _STATION_EDIT |
 * | CANCELLED_BY_REQUESTER | CANCELLED_BY_REQUESTER                |
 * | EXPIRED                | EXPIRED                               |
 *
 * Os dois filtros de cancelamento espelham o badge da linha: o médico desistir
 * da própria troca ("Cancelado") é outro evento para quem trabalha a fila do
 * que o fluxo recusá-la ("Reprovado").
 *
 * Sem `statuses`, cada endpoint mantém seu default (fila: IN_ADMIN_QUEUE;
 * histórico: terminais). Com `statuses`, o filtro sobrepõe esse default.
 */
export enum HandoverStatusFilter {
  IN_TRANSITION = 'IN_TRANSITION',
  IN_ADMIN_QUEUE = 'IN_ADMIN_QUEUE',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED_BY_REQUESTER = 'CANCELLED_BY_REQUESTER',
  EXPIRED = 'EXPIRED'
}

export interface ListApprovalHistoryParams {
  query?: string
  scheduleId?: number
  healthUnitId?: number
  startDate?: string
  endDate?: string
  expirationStartDate?: string
  expirationEndDate?: string
  operationalGroups?: string[]
  statuses?: HandoverStatusFilter[]
  page?: number
  perPage?: number
}
